import isTypedArrayMember from '@/common/utils/typescript/isTypedArrayMember'
import logger from '@/utils/logger'

import { USER_AUTH_ROLES, USER_ROLES_HIERARCHY } from '@/client/services/userRole/constants'
import type { StoredUserAuthRole, UserAuthRole } from '@/client/services/userRole/types'

import type { UserLike } from './types'

export default function getUserRoles(user: UserLike): UserAuthRole[] {
  const roles = new Set<UserAuthRole>()

  if (user.id != null && user.id !== 0) {
    // Add authenticated scope if user is not dummy
    roles.add('user:basic')
  }

  function addRole(role: StoredUserAuthRole) {
    // Do not add "stored" non-ACL roles
    if (!isTypedArrayMember(role, USER_AUTH_ROLES)) {
      // No op
      return
    }

    if (roles.has(role)) {
      return
    }
    roles.add(role)
    if (role in USER_ROLES_HIERARCHY) {
      USER_ROLES_HIERARCHY[role].forEach(addRole)
    } else {
      logger.error(`Role#${role} is not recognized for User#${user.id}`)
    }
  }

  if (user.roles != null) {
    user.roles.forEach(addRole)
  }

  return Array.from(roles)
}
